import { Component, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { stepStatus } from '../../../../data/constants/step-status';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';


// import { TaskStep } from 'src/app/data/models/task-step.model';
// import { PetitionerService } from 'src/app/services/petitioner.service';
import * as fromTask from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import * as Task from 'src/app/modules/superTask/task-state/actions/task.actions';
import { StatusPercentageMap, SubTask, SuperTask, VisaTypeList, DEPENDENT_VISAS } from 'app-models';
import { LookupService } from 'src/app/services/lookup-data.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import moment from 'moment';
import { CustomQuestionnaireService } from 'src/app/modules/custom-questionaire/services/custom-questionnaire.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddAdditionalDetailsComponent } from './add-additional-details/add-additional-details.component';
import { PetitionerService } from 'src/app/services/petitioner.service';

@Component({
  selector: 'app-task-summary-tab',
  templateUrl: './task-summary-tab.component.html',
  styleUrls: ['./task-summary-tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskSummaryTabComponent implements OnInit {
  @Output() tabChangeValue = new EventEmitter<number>();
  dataLogStatus: boolean = false;
  elapseTime;
  subTaskList: SubTask[];
  statusPercentageMap: StatusPercentageMap[];
  petitionTaskObj: any = {};
  observableSubscription$ = new Subject();
  rfeTaskObj: any = {};
  userType = '';
  chartData;
  assignToList = [];
  assignToEmployee: any;
  chartOption;
  petitionPresent = false;
  rfePresent = false;
  disableRfe = false;
  displayDialog = false;
  selectedTaskTypeCode;
  superTaskDetails: any;
  visaTypeArray = VisaTypeList;
  dependentVisaArray = DEPENDENT_VISAS;
  companyId: any;
  toggleStatus = "taskDetails";
  differenceInDays: number;
  dueDays: any;
  dueDate: any;
  overDueDays: any;
  cusSubTaskList: any;
  cusSummeryStepList: any;
  summeryStepList: any;
  checkSummeryDetails: boolean;
  taskDueDate: any;
  customStepList: any;
  dynamicDialogRef: DynamicDialogRef;
  superTask: SuperTask;
  selectedChartDataFlag: string;
  isSimplifyData: boolean;
  taskLevelData: any;
  beneficiaryDetails: any = {};

  constructor(
    private store: Store<fromTask.State>,
    private router: Router,
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private customQuestionnaireService: CustomQuestionnaireService,
    public dialogService: DialogService,
    private petitionerService: PetitionerService
  ) {
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  ngOnInit() {
    //console.log('here');
    sessionStorage.setItem('tempBeneficiaryEmployeeId', sessionStorage.getItem('beneficiaryId'));
    const benData = JSON.parse(sessionStorage.getItem('beneficiaryId'));
    const companyId = parseInt(sessionStorage.getItem('companyId'));
    if (sessionStorage.getItem('taskDetailsList') && !isNaN(companyId) && !isNaN(benData)) {
      const taskData = JSON.parse(sessionStorage.getItem('taskDetailsList'));
      this.petitionerService.getTaskLevelData(taskData[0].taskTypeId, companyId, benData).subscribe((element) => {
        this.taskLevelData = {
          "taskTypeId": element.taskTypeId,
          "companyId": element.companyId,
          "taskType": element.taskType,
          "taskTypeCd": element.taskTypeCd,
          "visaType": element.visaType,
          "visaTypeCd": element.visaTypeCd,
          "petitionType": element.petitionType,
          "petitionTypeCd": element.petitionTypeCd,
          "subTaskType": element.subTaskType,
          "subTaskTypeCd": element.subTaskTypeCd,
          "visaTemplateCode": element.visaTemplateCode,
          "id": element.beneficiaryId, // beneficiary id
          "beneficiaryName": element.beneficiaryName
        };
        this.beneficiaryDetails.beneficiaryEmployeeId = element.beneficiaryId;
      });
    }

    this.store.dispatch(new Task.SetActiveSubTaskIndex(0));
    this.checkSummeryDetails = true;
    this.onLoadFunctions();
    this.companyId = parseInt(sessionStorage.getItem('companyId'));
    if (this.companyId) {
      this.lookupService
        .getUsersOfCompany(this.companyId)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((data) => {
          this.assignToList = data;
        });
    }
    let dueDate = new Date();
    let currentDate = new Date(this.dueDate)
    let diffInTime = currentDate.getTime() - dueDate.getTime();
    this.differenceInDays = diffInTime / (1000 * 3600 * 24);
    this.dueDays = this.differenceInDays.toFixed(0);
    this.dueDays++;
    if (this.dueDays < 0) {
      this.overDueDays = Math.abs(this.dueDays);
    }
  }
  onLoadFunctions() {
    combineLatest([
      this.store.select(fromTask.getSubTaskList),
      this.store.select(fromTask.getSuperTask),
    ])
    .pipe(take(1))
    .subscribe(([subTaskList, superTask]) => {
      //console.log("supertask");
      this.superTask = superTask;
      let taskId = superTask.visaType ? superTask.visaType.code : superTask.immigrationType ? superTask.immigrationType.code : subTaskList[0].taskTypeCode;
      const tempVerson: any = subTaskList[0].stepOverviewList[0];
      if (this.superTask?.visaType?.code === 'H1-B') {
        sessionStorage.setItem('simplifyType', this.superTask?.petitionType?.code);
        sessionStorage.setItem('isSimplify', tempVerson?.version);
      }
      if (tempVerson && tempVerson.version == 'CWF') {
        this.isSimplifyData = true;
      } else {
        this.isSimplifyData = false;
      }
      this.lookupService.getTask(subTaskList[0].id, taskId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
        let companyId = res.createdByUserType === "Attorney" ? res.attorneyId : res.companyId;
        this.subTaskList = subTaskList;
        if (companyId) {
          this.customQuestionnaireService.getCustomStepsDetails(companyId, res.taskTypeId).pipe(takeUntil(this.observableSubscription$)).subscribe((cqData: any) => {
            if (this.subTaskList[0]?.customStepOverviewList?.length) {
              cqData.customStepList = this.mergeObjectsById(cqData.customStepList, this.subTaskList[0].customStepOverviewList)
            }
            if (subTaskList[0].customStepOverviewList && subTaskList[0].customStepOverviewList.length > 0) {
              this.cusSummeryStepList = cqData.customStepList;
              let customSteps = [];
              this.cusSummeryStepList.forEach(element => {
                if (element.completionStatus === "PENDING") {
                  element.stepStatusCode = "INPROGRESS";
                  element.stepStatusName = "In progress";
                }
                if (element.isBeneficiaryEditable || element.isBeneficiaryVisible) customSteps.push(element)
              });
              this.customStepList = customSteps;
              // if (subTaskList) {
              this.superTaskDetails = superTask;
              //console.log('this.superTaskDetails:',this.superTaskDetails);
              // this.cusSubTaskList = subTaskList;
              let stepOverview: any = this.subTaskList.map(e => e.stepOverviewList)[0] || [];
              for (var i = 0; i < this.customStepList.length; i++) {
                let allindex = stepOverview.filter(x => x.stepName === this.customStepList[i].previousStepName);
                let index = stepOverview.findIndex(x => x.stepName === this.customStepList[i].previousStepName);
                this.customStepList[i]['isCustomStep'] = true;
                this.customStepList[i].stepPosition === 'before' ? '' : index = allindex.length > 1 ? index + 2 : index + 1
                stepOverview.splice(index, 0, this.customStepList[i]);
              }

              this.summeryStepList = stepOverview;
            } else {
              this.summeryStepList = this.subTaskList[0].stepOverviewList || [];
            }
            this.taskDueDate = this.superTask.taskDueDate ? moment(this.superTask.taskDueDate).format('MM/DD/YYYY') : '';
            this.dueDate = this.superTask.taskDueDate ? moment(this.superTask.taskDueDate).format('MM-DD-YYYY') : '';
            this.getPetitionDetails();
            // }
          });
        } else {
          this.summeryStepList = this.subTaskList[0].stepOverviewList || [];
          this.taskDueDate = this.superTask.taskDueDate ? moment(this.superTask.taskDueDate).format('MM/DD/YYYY') : '';
          this.dueDate = this.superTask.taskDueDate ? moment(this.superTask.taskDueDate).format('MM-DD-YYYY') : '';
          this.getPetitionDetails();
        }
      });
    });
  }


  mergeObjectsById(arr1, arr2) {
    const mergedObjects = arr1.map(obj1 => {
      const matchingObj2 = arr2.find(obj2 => obj2.stepId === obj1.id);
      return matchingObj2 ? { ...obj1, ...matchingObj2 } : obj1;
    });

    // Add objects from arr2 with unique ids (not found in arr1) to the merged array
    const uniqueObjectsFromArr2 = arr2.filter(obj2 => !arr1.some(obj1 => obj1.id === obj2.stepId));
    mergedObjects.push(...uniqueObjectsFromArr2);
    mergedObjects.forEach(element => {
      element.overviewId = element.id;
      element.id = element.stepId;
    });


    return mergedObjects;
  }

  asnDropDown(assignToEmployee, asnDropDown, event) {
    this.assignToEmployee = event.target.value;
  }
  getPetitionDetails() {
    let temp = [];
    if (this.subTaskList !== undefined) {
      this.selectedTaskTypeCode = this.subTaskList[0].taskTypeCode;
      this.subTaskList.forEach(element => {
        switch (element.taskTypeCode) {
          case 'PETITION':
            if (this.visaTypeArray.includes(this.superTask.visaType?.code) || this.dependentVisaArray.includes(this.superTask.visaType?.code)) {
              element.visaTypeName = this.superTask.visaType.name;
            } else {
              element.visaTypeName = this.superTask.immigrationCategory?.name;
            }
            temp = [];
            const petitionTaskObjLocal = element.stepOverviewList;
            try {
              if (petitionTaskObjLocal && petitionTaskObjLocal.length > 0) {
                petitionTaskObjLocal.forEach((item) => {
                  item.isVisible = (this.userType === 'Attorney' && item.isAttorneyAction === 1) ||
                    (this.userType === 'Beneficiary' && item.isBeneficiaryVisible === 1) ||
                    (this.userType === 'Petitioner' && item.isPetitionerAction === 1);
                  if (item.isVisible) {
                    if (item.layoutCode !== 'WAIT') {
                      temp.push(item);
                    }
                  }
                });
                this.petitionPresent = true;
                this.petitionTaskObj = element;
                this.petitionTaskObj.stepOverviewList = temp;
              }
            } catch (error) {
              console.log('summary tab error', error);
            }
            if (element.isOutside) {
              this.petitionTaskObj.stepOverviewList.forEach((stepOverview) => {
                if (stepOverview.stepStatusCode != 'COMPLETE') {
                  this.disableRfe = true;
                }
              });
            }

            break;
          case 'RFE':
            temp = [];
            const rfeTaskObjLocal = element.stepOverviewList;
            if (rfeTaskObjLocal && rfeTaskObjLocal.length > 0) {
              rfeTaskObjLocal.forEach((item) => {
                item.isVisible = (this.userType === 'Attorney' && item.isAttorneyAction === 1) ||
                  (this.userType === 'Beneficiary' && item.isBeneficiaryVisible === 1) ||
                  (this.userType === 'Petitioner' && item.isPetitionerAction === 1);
                if (item.isVisible) {
                  temp.push(item);
                }
              });
              this.rfePresent = true;
              this.rfeTaskObj = element;
              this.rfeTaskObj.stepOverviewList = temp;
            }
            break;
        }
        this.elapseTime = element.lapseTimeDays;
        if (element.statusCode == stepStatus.Inprogress) {
          this.selectedTaskTypeCode = element.taskTypeCode;
        }
        // }
      });
      this.getStatusMap();
    }
  }

  getStatusMap() {
    const data: any = {};
    const labels: any = [];
    const values: any = [];
    const backgroundColor = [
      '#e1e1e1',
      '#86d87f',
      '#01a0da'
    ];
    this.selectedChartDataFlag = 'Completed';
    this.subTaskList.forEach(element => {
      if (element.taskTypeCode == this.selectedTaskTypeCode) {
        this.statusPercentageMap = element['statusPercentageMap'];
        if (this.statusPercentageMap !== undefined) {
          for (const prop in this.statusPercentageMap) {
            if (this.statusPercentageMap.hasOwnProperty(prop)) {
              labels.push(prop);
              values.push(this.statusPercentageMap[prop]);
            }
          }
          data.labels = labels;
          data.datasets = [];
          const set: any = {};
          set.data = values;
          set.backgroundColor = backgroundColor;
          data.datasets.push(set);
          this.chartData = data;
          this.chartOption = {
            cutoutPercentage: 95,
            legend: {
              position: 'right'
            }
          };
        }
      }
    });
  }

  switchTab() {
    this.tabChangeValue.emit(1);
  }

  onInitiateSubTask(event, subTask: SubTask) {
    event.stopPropagation();
    const subTaskTypeCode = subTask.taskTypeCode;
    switch (subTaskTypeCode) {
      case 'PWD':
        this.router.navigate([`./../green-card/pwd`], { relativeTo: this.route });
        break;
      case 'RECEFF':
        this.router.navigate([`./../green-card/re`], { relativeTo: this.route });
        break;
      case 'PETITION':
        if (this.superTaskDetails.visaType && this.superTaskDetails.visaType.code) {
          this.router.navigate([`./../visa/${this.superTaskDetails.visaType.code}`], { relativeTo: this.route });
        } else {
          this.router.navigate([`./../visa/${this.superTaskDetails.immigrationCategory?.code}`], { relativeTo: this.route });
        }

        break;
      case 'RFE':
        if (this.disableRfe) {
          this.displayDialog = true;
        }
        else {
          // combineLatest([
          //   this.store.select(fromTask.getRFETabIndex)
          //  ]).subscribe(([rfeTabIndex]) => {
          //   this.superTaskSummaryService.tabIndexBehaviorSubject.next(rfeTabIndex);
          //  }); subTaskList
          const index = this.subTaskList.findIndex(x => x.id === subTask.id);
          this.store.dispatch(new Task.SetRFEIndex(index));
          // this.store.dispatch(new Task.SetRFEIndex(response));
          //   this.router.navigate([`./../rfe`], { relativeTo: this.route });
        }
        break;
      case 'I130':
        this.router.navigate([`./../immigration/${subTaskTypeCode}`], { relativeTo: this.route });
        break;
    }
  }
  toggleMode(mode) {
    this.toggleStatus = mode;
    if (mode == 'dataLog') {
      this.dataLogStatus = true;
    } else {
      this.dataLogStatus = false;
    }
  }

  getDayDiff(startDate: Date, endDate: Date): number {
    const msInDay = 24 * 60 * 60 * 1000;

    return Math.round(Math.abs(Number(endDate) - Number(startDate)) / msInDay);

  }

  handleAddClick(subTask: SubTask) {
    this.dynamicDialogRef = this.dialogService.open(AddAdditionalDetailsComponent, {
      width: '70%',
      contentStyle: { 'z-index': '1000', 'padding-bottom': '15px', 'overflow-y': 'hidden !important' },
      styleClass: 'add-additional-details-dialog',
      closable: false,
      showHeader: false,
      closeOnEscape: false,
      modal: true,
      dismissableMask: true,
      data: { subTask: subTask, superTask: this.superTask }
    });
  }

}